import styled from 'styled-components';
import { SearchInput } from '../input';
import { ZTooltip } from '../ztooltip';

export const TREE_SIDEBAR_WIDTH = 300;

export const SidebarContainer = styled.div<{ position: string; $isMainSidebar?: boolean; $isDialog?: boolean }>`
    position: ${(props) => (props.$isDialog ? 'static' : props.position)};
    width: ${(props) => (props.$isDialog ? '100%' : `${TREE_SIDEBAR_WIDTH}px`)};
    box-sizing: border-box;
    background-color: transparent;
    overflow-x: hidden;
    overflow-y: auto;
    /* Sticky sidebars inside LeftSidebarLayout inherit this offset from the measured page header. */
    top: ${(props) => (props.position === 'sticky' ? 'var(--sidebar-sticky-top, 0px)' : '0')};
    max-height: ${(props) => (props.position === 'sticky' ? 'calc(100vh - var(--sidebar-sticky-top, 0px))' : 'none')};
    left: 0;
`;

export const SidebarButtons = styled.div`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    margin-left: auto;
`;

export const TooltipCategories = styled(ZTooltip)`
    max-width: max-content;
`;

export const StyledSpan = styled.span<{ maxWidth?: string }>`
    max-width: ${(props) => props.maxWidth || 'max-content'};
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const SidebarListItem = styled.div<{ $selected?: boolean; disabled?: boolean; $indent?: boolean; $notClickable?: boolean }>`
    display: flex;
    align-items: center;
    padding: 6px 9px 6px ${(props) => (props.$indent !== false ? '9px' : '0')};
    margin-bottom: 4px;
    cursor: ${(props) => (props.$notClickable ? 'default' : 'pointer')};
    flex-wrap: nowrap;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    transition: all 0.2s ease;
    background: ${(props) => (props.$selected ? 'rgb(0 0 0 / 5%)' : 'transparent')};
    border-radius: ${(props) => (props.$selected ? '8px' : 'unset')};

    span {
        box-sizing: border-box;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1;
        min-width: 0;
    }

    ${(props) =>
        !props.disabled &&
        !props.$notClickable &&
        `
    &:hover {
        background: rgb(0 0 0 / 5%);
        border-radius: 8px;
    }`}

    ${(props) =>
        props.disabled &&
        `
    color: #BBB;
    `}
`;

export const SidebarHeaderContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 0 0 12px 0;
    position: relative;
`;

export const SidebarHeader = styled.h1`
    margin: 0;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    font-weight: 600;
    color: #263238;
`;

export const SidebarSearchInput = styled(SearchInput)`
    padding: 5px;
    font-size: 10px;
    width: 100%;
    flex: 1;
    height: 30px;
`;
